import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-integration',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.integration.title" 
      icon="construction"
      >
    </app-placeholder-page>
  `
})
export class IntegrationComponent {}